/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_EmptyInputs */

const en_planner_empty = /** @type {(inputs: Planner_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suggestion – no recipe fit.`)
};

const de_planner_empty = /** @type {(inputs: Planner_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Vorschlag – kein Rezept passte.`)
};

/**
* | output |
* | --- |
* | "No suggestion – no recipe fit." |
*
* @param {Planner_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_empty = /** @type {((inputs?: Planner_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_empty(inputs)
	return en_planner_empty(inputs)
});